'use client';

import { cn } from '@workspace/lib';
import { IMAGE_DIMENSIONS, useProductSummary } from './useProductSummary';
import { ProductSummaryProps } from './product-summary.types';
import { ProductSummaryContent } from './ui/ProductSummaryContent';
import { ProductSummaryMedia } from './ui/ProductSummaryMedia';

export function ProductSummary({ block }: ProductSummaryProps) {
  const {
    isActive,
    resolvedHeading,
    backgroundClass,
    hasMedia,
    imageOrderClass,
    contentOrderClass,
    handleAskGregClick,
    getOpenInNewTab,
    description,
    ctaUnderHeadline,
    ctaUnderDescription,
    isVideo,
    video,
    image,
    headline,
  } = useProductSummary(block);

  if (isActive === false) return null;

  return (
    <div className={cn('product-summary-bg w-full', backgroundClass)}>
      <div className="product-summary-container md:px-full-banner md:py-3xl px-md py-xl porta-container">
        <div className="product-summary-wrapper w-full flex flex-col md:flex-row gap-lg md:gap-3xl items-center justify-center">
          {/* Media */}
          <div
            className={cn(
              'image-container',
              imageOrderClass,
              IMAGE_DIMENSIONS.className,
              'bg-transparent flex items-center justify-center w-full h-81.75',
            )}
          >
            {hasMedia ? (
              <ProductSummaryMedia isVideo={isVideo} video={video} image={image} headline={headline} />
            ) : (
              <div className="text-secondary-400 text-center h-81.75 w-full bg-light-silver flex items-center justify-center md:h-136"></div>
            )}
          </div>

          {/* Content */}
          <div className={cn('content-container', contentOrderClass, 'flex flex-col flex-1 gap-sm md:gap-lg w-full')}>
            <ProductSummaryContent
              resolvedHeadingText={resolvedHeading.resolvedHeadingText}
              headingFontClass={resolvedHeading.headingFontClass}
              description={description}
              ctaUnderHeadline={ctaUnderHeadline}
              ctaUnderDescription={ctaUnderDescription}
              onAskGregClick={handleAskGregClick}
              getOpenInNewTab={getOpenInNewTab}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
